<template>
    <div class="p-fluid formgroup-inline grid">
        <div class="field col-1 font-medium">No</div>
        <div class="field col-4 font-medium">Test</div>
        <div class="field col-2 font-medium">Value</div>
    </div>
    <div v-for="(item, index) in assessements" class="p-fluid formgroup-inline grid">
        <div class="field col-1">
            {{ item.no }}
        </div>
        <div class="field col-4">
            {{ item.description }}
        </div>
        <div class="field col-2 mt-2">
            <Dropdown
                :options="options"
                placeholder="Select Division"
                v-model='item.value'
                required="true"/>
        </div>
    </div>
    <hr />
    <div class="p-fluid">
        <div class="field grid">
            <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Recommendation</label>
            <div class="col-12 md:col-5">
                <Dropdown v-model="form.psy_recommendation" :options="option_recommendations" placeholder="Select Recommendation" required="true"/>
            </div>
        </div>
    </div>
    <hr />
    <div class="field grid">
        <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Psikolog</label>
        <div class="col-12 md:col-5">
            <InputText id="psikolog" v-model="form.psychologist"/>
        </div>
    </div>
    <div class="field grid">
        <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Psikotest</label>
        <div class="col-12 md:col-5">
            <InputText id="psikotest" v-model="form.psychological_test"/>
        </div>
    </div>
    <div class="field grid">
        <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Keterangan</label>
        <div class="col-12 md:col-5">
            <Textarea
                id="description"
                name="description"
                v-model="form.description"
                required="true"
                rows="5"
                cols="50"
            >
            </Textarea>
        </div>
    </div>
    <div class="field grid">
        <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Recruiter</label>
        <div class="col-12 md:col-5">
            <Dropdown
                    v-model="form.recruiter_id"
                    :options="employees"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Select Division" required="true"/>
        </div>
    </div>
</template>
<script>
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import Calendar from "primevue/calendar";
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";
import axios from "axios";

export default {
    components: {
        Button, Dropdown, Calendar, InputText, Textarea,
    },
    props: ['models'],
    data() {
        return {
            form: this.$page.props.psikotest ?? { description: "Mempunyai kepribadian yang sangat jujur introvert. Ia tergolong orang yang cukup mampu untuk berkomunikasi dan mampu beradaptasi dengan lingkungan serta  mampu bersosialisasi. Penyesuaian dirinya cukup baik. Dalam bekerja, ia cukup sistematis dan mengikuti prosedur yang berlaku. Motivasi yang dimilikinya baik. Pemecahan masalahnya baik." },
            assessements: [
                {no: 1, description: "Psi. Akademik", field_name: "psy_academic", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_academic},
                {no: 2, description: "Psi. Komunikasi", field_name: "psy_communication", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_communication},
                {no: 3, description: "Psi. Adaptasi", field_name: "psy_adaptation", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_adaptation},
                {no: 4, description: "Psi. Sosialisasi", field_name: "psy_social", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_social},
                {no: 5, description: "Psi. Teamwork", field_name: "psy_teamwork", value: this.$page.props.psikotest === undefined? 'Baik' : this.$page.props.psikotest.psy_teamwork},
                {no: 6, description: "Psi. Pemecahan Masalah", field_name: "psy_problem_solving", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_problem_solving},
                {no: 7, description: "Psi. Kecepatan Kerja", field_name: "psy_speed", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_speed},
                {no: 8, description: "Psi. Motivasi", field_name: "psy_motivation", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_motivation},
                {no: 9, description: "Psi Kepribadian", field_name: "psy_personality", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_personality},
                {no: 10, description: "Psi Wawasan", field_name: "psy_knowledge", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_knowledge},
                {no: 11, description: "Psi Penampilan", field_name: "psy_appearance", value: this.$page.props.psikotest === undefined ? 'Baik' : this.$page.props.psikotest.psy_appearance},
            ],
            submitted: false,
            options: ['Baik Sekali', 'Baik', 'Cukup', 'Kurang'],
            option_recommendations: ['Disarankan', 'Dapat Disarankan', 'Masih Dapat Disarankan', 'Tidak Disarankan'],
            employees: {},
        }
    },
    computed: {

    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData(){
            axios.get(`${this.$page.props.appUrl}api/employees`)
            .then((data)=>{
                this.employees = data.data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Employees, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
        }
    }
}
</script>
